import React from "react";
import { useHistory } from "react-router-dom";
import { injectIntl } from "react-intl";
import { COMMON_UTIL } from "@/common/util/common.util";
import { callBrowser } from "@/nativebridge/JsToNative";
import { inject, observer } from "mobx-react";
import { Stack, Typography, Box } from "@mui/material";
import { QuickMenuWrap, QuickMenuBox } from "../Styled/HomeStyled";
import QuickMenuIcon01_1 from "@/common/Images/QuickMenuIcon01_1.svg";
import QuickMenuIcon01_2 from "@/common/Images/QuickMenuIcon01_2.svg";
import QuickMenuIcon02 from "@/common/Images/QuickMenuIcon02.svg";
import { c } from "@/theme/colorUtils";
import { useToast } from "@/components/useToast";



const QuickMenu = ({ intl }) => {
  const history = useHistory();
  const { showDeleteToast } = useToast();

  // 원래 클릭 동작
  const handlePokoroSettingClickInternal = () => {
    if (COMMON_UTIL.isWebView()) {
      // 앱에서는 기존대로 포코로 설정 페이지로 이동
      history.push("/pokoroSetting");
    } else {
      // 웹에서는 팝업 메시지 표시
      showDeleteToast("App에서만 사용 가능한 메뉴입니다");
    }
  };

  // QuickMenuBox 클릭 핸들러 (JSX용)
  const handlePokoroSettingClick = (event) => {
    handlePokoroSettingClickInternal(); // 원래 동작 수행
    event.currentTarget.blur();         // 클릭 후 포커스 제거
  };

  const handleIconClick = () => {
    const url = 'https://pokoro.notion.site/13d3d084743980719773eaf6db49643f?v=13d3d084743980caa8df000cb3a32457&pvs=74';

    if (COMMON_UTIL.isWebView()) {
      callBrowser(url);
    } else {
      setTimeout(() => {
        window.open(url, '_blank');
      }, 100);
    }
  };
  return (
    <QuickMenuWrap>
      <QuickMenuBox onClick={handlePokoroSettingClick} className="quickMenuBox01 primary" >
        <Box className="IconBox">
          <img src={QuickMenuIcon01_1} alt="PokoroSetting" className="PokoroSetting_1" />
          <img src={QuickMenuIcon01_2} alt="PokoroSetting" className="PokoroSetting_2" />
        </Box>
        <Stack gap={0.5} width="100%" alignItems="center">
          <Typography variant="subtitle1" fontWeight={700}>
              {intl.formatMessage({ id: "pokoro_settings" })} {/* 포코로 설정 */}
          </Typography>
          <Typography variant="body2" color={c.text02} textAlign="center" whiteSpace="pre-wrap">
              {intl.formatMessage({ id: "quickMenu01_desc" })} {/* Wi-Fi 또는 언어 설정 변경 */}
          </Typography>
        </Stack>
      </QuickMenuBox>
      
      <QuickMenuBox onClick={handleIconClick} className="quickMenuBox02 primary">
        <Box className="IconBox">
          <img src={QuickMenuIcon02} alt="PokoroSetting" />
        </Box>
        <Stack gap={0.5} width="100%" alignItems="center">
          <Typography variant="subtitle1" fontWeight={700}>
            {intl.formatMessage({ id: "guide" })} {/* 가이드 */}
          </Typography>
            <Typography variant="body2" color={c.text02} textAlign="center" whiteSpace="pre-wrap">
            {intl.formatMessage({ id: "quickMenu02_desc" })} {/* 포코로 앱 및 디바이스 사용법 */}
          </Typography>
        </Stack>
      </QuickMenuBox>

    </QuickMenuWrap>
  );
};

export default injectIntl(
  inject("homeStore", "pronunciationStore", "reportStore", "languageStore")(observer(QuickMenu))
);
